module.exports = __webpack_public_path__ + "static/media/hostIcon.14239a82.svg";